<ng-container [ngSwitch]="type">
    <i *ngSwitchCase="EIconType.FONT_AWESOME" [class]="icon"></i>
    <mat-icon *ngSwitchCase="EIconType.MATERIAL">{{icon}}</mat-icon>
    <mat-icon *ngSwitchCase="EIconType.MATERIAL_OUTLINE" fontSet="material-icons-outlined">{{icon}}</mat-icon>
    <mat-icon *ngSwitchCase="EIconType.CUSTOM" [svgIcon]="icon"></mat-icon>
    <mat-icon *ngSwitchCase="EIconType.CUSTOM_WHITE" class="iwhite" [svgIcon]="icon"></mat-icon>
</ng-container>
